export default __webpack_public_path__ + "static/media/attendance_icon.2d524f34.svg";